export default "__VITE_ASSET__DHHDYiQp__"